import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import Parceiros from './pages/Parceiros';
import Produtos from './pages/Produtos';
import Eventos from './pages/Eventos';
import Catalogo from './pages/Catalogo';
import Contacto from './pages/Contacto';
import FAQ from './pages/FAQ';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade';
import { Toaster } from './components/ui/sonner';
import { Toaster as RadixToaster } from './components/ui/toaster';
import { AdminProvider } from './context/AdminContext';
import ProtectedRoute from './admin/ProtectedRoute';
import AdminLayout from './admin/AdminLayout';
import Login from './admin/pages/Login';
import ScrollToTop from './components/ScrollToTop';
import Dashboard from './admin/pages/Dashboard';
import AdminProducts from './admin/pages/Products';
import AdminParceiros from './admin/pages/Parceiros';
import Appearance from './admin/pages/Appearance';
import Images from './admin/pages/Images';
import Messages from './admin/pages/Messages';
import Settings from './admin/pages/Settings';
import Homepage from './admin/pages/Homepage';
import MenuEditor from './admin/pages/MenuEditor';
import WhatsAppButton from './components/WhatsAppButton';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AdminProvider>
        <ScrollToTop />
        <div className="App">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={
              <>
                <Header />
                <Home />
                <Footer />
                <WhatsAppButton />
              </>
            } />
            <Route path="/parceiros" element={
              <>
                <Header />
                <Parceiros />
                <Footer />
                <WhatsAppButton />
              </>
            } />
            <Route path="/produtos" element={
              <>
                <Header />
                <Produtos />
                <Footer />
                <WhatsAppButton />
              </>
            } />
            <Route path="/eventos" element={
              <>
                <Header />
                <Eventos />
                <Footer />
                <WhatsAppButton />
              </>
            } />
            <Route path="/catalogo" element={
              <>
                <Header />
                <Catalogo />
                <Footer />
                <WhatsAppButton />
              </>
            } />
            <Route path="/contacto" element={
              <>
                <Header />
                <Contacto />
                <Footer />
                <WhatsAppButton />
              </>
            } />
            <Route path="/faq" element={
              <>
                <Header />
                <FAQ />
                <Footer />
                <WhatsAppButton />
              </>
            } />
            <Route path="/politica-privacidade" element={
              <>
                <Header />
                <PoliticaPrivacidade />
                <Footer />
                <WhatsAppButton />
              </>
            } />

            {/* Admin Routes */}
            <Route path="/admin/login" element={<Login />} />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminLayout />
                </ProtectedRoute>
              }
            >
              <Route path="dashboard" element={<Dashboard />} />
              <Route path="products" element={<AdminProducts />} />
              <Route path="parceiros" element={<AdminParceiros />} />
              <Route path="homepage" element={<Homepage />} />
              <Route path="menu" element={<MenuEditor />} />
              <Route path="appearance" element={<Appearance />} />
              <Route path="images" element={<Images />} />
              <Route path="messages" element={<Messages />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
          <Toaster />
          <RadixToaster />
        </div>
      </AdminProvider>
    </BrowserRouter>
  );
}

export default App;
